export const signInUtm =
  "/auth/sign-in?utm_source=pathrade-web&utm_medium=product&utm_campaign=product-auth-signin-link&utm_content=cta-button-link-top&utm_term=v240724";
export const signUpUtm =
  "/auth/sign-up?utm_source=pathrade-web&utm_medium=product&utm_campaign=product-auth-signup-link&utm_content=cta-button-link-top&utm_term=v240724";
